import { Fragment } from 'react'
import {
	Card,
	Chip,
	Collapse,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { IssueDetailPanel } from './IssueDetailPanel'
import { STATUS_COLORS, PRIORITY_COLORS } from './issues-constants'

export function IssueTable({
	issues,
	expandedIssue,
	onToggleExpand,
	adminNotes,
	onAdminNotesChange,
	onSaveNotes,
	onStatusChange,
	getAttachmentUrl,
	savingNote,
}) {
	return (
		<TableContainer component={Card}>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>Title</TableCell>
						<TableCell>Customer</TableCell>
						<TableCell>Sensor</TableCell>
						<TableCell>Status</TableCell>
						<TableCell>Priority</TableCell>
						<TableCell>Created</TableCell>
						<TableCell padding="none" width={48} />
					</TableRow>
				</TableHead>
				<TableBody>
					{issues.map((issue) => (
						<Fragment key={issue.id}>
							<TableRow
								hover
								sx={{ cursor: 'pointer' }}
								onClick={() => onToggleExpand(issue.id)}
							>
								<TableCell>
									<Typography variant="body2" fontWeight="medium">
										{issue.title}
									</Typography>
								</TableCell>
								<TableCell>{issue.customer?.name || 'N/A'}</TableCell>
								<TableCell>
									<Typography variant="body2" component="code" sx={{ fontSize: '0.8rem' }}>
										{issue.sensor_id || '—'}
									</Typography>
								</TableCell>
								<TableCell>
									<Chip
										label={issue.status.replace('_', ' ')}
										color={STATUS_COLORS[issue.status] || 'default'}
										size="small"
									/>
								</TableCell>
								<TableCell>
									<Chip
										label={issue.priority}
										color={PRIORITY_COLORS[issue.priority] || 'default'}
										size="small"
									/>
								</TableCell>
								<TableCell>
									{new Date(issue.created_at).toLocaleDateString()}
								</TableCell>
								<TableCell padding="none">
									<IconButton size="small">
										{expandedIssue === issue.id ? <ExpandLess /> : <ExpandMore />}
									</IconButton>
								</TableCell>
							</TableRow>
							<TableRow key={`${issue.id}-detail`}>
								<TableCell colSpan={7} sx={{ py: 0, borderBottom: 'none' }}>
									<Collapse in={expandedIssue === issue.id} timeout="auto" unmountOnExit>
										<IssueDetailPanel
											issue={issue}
											adminNotes={adminNotes[issue.id] ?? issue.admin_notes ?? ''}
											onAdminNotesChange={(v) => onAdminNotesChange(issue.id, v)}
											onSaveNotes={() => onSaveNotes(issue.id)}
											onStatusChange={(s) => onStatusChange(issue.id, s)}
											getAttachmentUrl={getAttachmentUrl}
											savingNote={savingNote === issue.id}
										/>
									</Collapse>
								</TableCell>
							</TableRow>
						</Fragment>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
